module.exports = __webpack_public_path__ + "static/media/TV-SCIS.b587e2bb.png";